import en from './en.json';
import de from './de.json';
import it from './it.json';
import id from './id.json';
import ro from './ro.json';
import ru from './ru.json';
import es from './es.json';
import nl from './nl.json';
import fr from './fr.json';
import zh from './zh.json';
// eslint-disable-next-line camelcase
import zh_tw from './zh_tw.json';
// eslint-disable-next-line camelcase
import pt_br from './pt_br.json';
// eslint-disable-next-line camelcase
import pt_pt from './pt_pt.json';
import pl from './pl.json';
import sv from './sv.json';
import el from './el.json';
import hu from './hu.json';
import da from './da.json';
import no from './no.json';
import fa from './fa.json';
import ua from './ua.json';
import tr from './tr.json';
import cz from './cz.json';
import ja from './ja.json';
import fi from './fi.json';
import ko from './ko.json';
import ky from './ky.json';

// eslint-disable-next-line camelcase
const pt = pt_pt;

export default {
  en,
  de,
  it,
  id,
  ro,
  ru,
  es,
  nl,
  fr,
  pt,
  // eslint-disable-next-line camelcase
  pt_br,
  // eslint-disable-next-line camelcase
  pt_pt,
  zh,
  // eslint-disable-next-line camelcase
  zh_tw,
  pl,
  sv,
  el,
  hu,
  da,
  no,
  fa,
  ua,
  tr,
  cz,
  ja,
  fi,
  ko,
  ky,
};
